// JavaScript to handle fixed navigation and active states
document.addEventListener('DOMContentLoaded', function () {
  const navMenu = document.querySelector('.nav-menu');
  const navLinks = document.querySelectorAll('.nav-link');
  const sections = document.querySelectorAll('section[id^="section-"]');
  const navHeight = navMenu.offsetHeight;
  const navOriginalPosition = navMenu.getBoundingClientRect().top + window.scrollY;
  // Function to update active menu item based on scroll position
  function updateActiveMenuItem() {
    const scrollPosition = window.scrollY;
    // Make navigation fixed when scrolled past its original position
    if (scrollPosition > navOriginalPosition) {
      navMenu.classList.add('fixed');
    } else {
      navMenu.classList.remove('fixed');
    }
    // Update active state based on which section is in view
    sections.forEach((section) => {
      const sectionTop = section.offsetTop - navHeight - 70; // Adjusted offset
      const sectionBottom = sectionTop + section.offsetHeight;
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        // Remove active class from all links
        navLinks.forEach((link) => {
          link.classList.remove('active');
        });
        // Add active class to current section's link
        const activeLink = document.querySelector(`a[href="#${section.id}"]`);
        if (activeLink) {
          activeLink.classList.add('active');
        }
      }
    });
  }
  // Initial call to set correct state
  updateActiveMenuItem();
  // Update on scroll
  window.addEventListener('scroll', updateActiveMenuItem);
  // Handle navigation click events
  navLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      // Remove active class from all links
      navLinks.forEach((link) => {
        link.classList.remove('active');
      });
      // Add active class to clicked link
      this.classList.add('active');
      // Get the target section
      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        // Calculate position to scroll to (accounting for fixed nav)
        const isNavFixed = navMenu.classList.contains('fixed');
        const offsetAdjustment = isNavFixed ? navHeight + 20 : 100;
        const scrollToPosition = targetSection.offsetTop - offsetAdjustment;
        // Scroll to the section
        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth',
        });
      }
    });
  });
});